import parseHTML from '../../../utilities/parseHTML';

export const testAttributes = {
    FOOTER_CONTAINER: 'footer-container',
    FOOTER_WRAPPER: 'footer-wrapper',
    FOOTER_MENU: 'footer-menu',
    FOOTER_DISCLOSURE: 'footer-disclosure',
    FOOTER_COPYRIGHT: 'footer_copyright',
};

export const disclosureContent = parseHTML(`
<p>
LMB OpCo, LLC, (dba Quicken Loans), is not acting as a lender or broker. The information provided by you to Quicken Loans is not an application for a mortgage loan, nor is it used to pre-qualify you with any lender. If you are contacted by a lender or broker advertising within our network, your quoted rate may be higher depending on your property location, credit score, loan-to-value ratio, debt-to-income ratio, and/or other factors. Quicken Loans does not offer its matching services in all states. This loan may not be available for all credit types, and not all service providers in the Quicken Loans network offer this or other products with interest-only options. The information that we provide is from companies which Quicken Loans and its partners may receive compensation. This compensation may influence the selection, appearance, and order of appearance on this site. The information provided by Quicken Loans does not include all financial services companies or all of their available product and service offerings. Article content appears via license from original author or content owner, including Rocket Mortgage.
</p>
<p>
Note: Actions on this website are recorded for quality assurance or training purposes. Input of data constitutes consent.
</p>
<p>
Quicken Loans is a registered trademark of Rocket Mortgage, LLC, used under license by LMB OpCo, LLC from Rocket Mortgage.
</p>
<p>
LMB Mortgage Services, Inc. | NMLS #167283
</p>
<p>
4859 W Slauson Ave #405 Los Angeles, CA 90056
</p>
`).parsed;

export const copyRight = parseHTML('QuickenLoans.com, a LMB Mortgage Services, Inc. company NMLS #167283, <a href="https://www.nmlsconsumeraccess.org/" target="_blank">www.nmlsconsumeraccess.org</a>').parsed;